import { render, staticRenderFns } from "./SubpagesButtons.vue?vue&type=template&id=0bc26f68&scoped=true"
import script from "./SubpagesButtons.vue?vue&type=script&lang=js"
export * from "./SubpagesButtons.vue?vue&type=script&lang=js"
import style0 from "./SubpagesButtons.vue?vue&type=style&index=0&id=0bc26f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc26f68",
  null
  
)

export default component.exports